import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const AuthGuard = ({ children }) => {
  const navigate = useNavigate();

  // Define public routes
  const publicRoutes = ["/login", "/forgot-password", "/reset-password", "/superadmin/onboard-tenant", "/docs"];

  // Check if the current route is public
  const isPublicRoute = publicRoutes.includes(window.location.pathname);

  useEffect(() => {
    const token = localStorage.getItem("token"); 
    if (!token && !isPublicRoute) {
      navigate("/login");
    }
  }, [isPublicRoute, navigate]);

  return children;
};

export default AuthGuard;